import { LoadingButton } from '@mui/lab';
import { CardActions, Typography } from '@mui/material';

/**
 * The properties for the question card footer component
 */
interface QuestionCardFooterProps {
  /**
   * Whether the question card is loading
   */
  isLoading: boolean;
  /**
   * A boolean to indicate if a answer has been selected. If so, the answer button is enabled
   */
  selectedAnswer: boolean;
  /**
   * The number of answers the user has correctly answered
   */
  completedQuestions: number;
  /**
   * The number of correctly answered questions the quiz requires in order to be considered complete
   */
  questionCountMinimum: number;
}

/**
 * The question card footer is used to have a consistent way to submit our answers, despite
 *  the question types being different. The answer button uses type submit to work within forms
 * @param props The props for the question card footer
 * @returns A component to show at the bottom of each question card
 */
const QuestionCardFooter = (props: QuestionCardFooterProps) => (
  <CardActions
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '1em',
    }}
  >
    <LoadingButton
      data-testid="answer-question-button-id"
      loading={props.isLoading}
      variant="contained"
      color="primary"
      disabled={props.isLoading || !props.selectedAnswer}
      type="submit"
    >
      Answer
    </LoadingButton>
    <Typography
      data-testid="questions-complete-id"
      gutterBottom
      marginBottom="0"
      variant="body1"
      component="h2"
      marginRight="5px"
    >
      Questions Complete{' '}
      <b>
        {props.completedQuestions}/{props.questionCountMinimum}
      </b>
    </Typography>
  </CardActions>
);

export default QuestionCardFooter;
